import { useEffect, useContext } from 'react';
import { useRouter } from 'next/router';
import { UserActivityContext } from '@context/UserActivityContext';

const InputDeviceActivity = () => {
  const router = useRouter();
  const { inputDeviceInteraction } = useContext(UserActivityContext);

  useEffect(() => {
    if (router?.events) {
      router.events.on('routeChangeStart', inputDeviceInteraction);
    }
    window.addEventListener('focus', inputDeviceInteraction);
    window.addEventListener('scroll', inputDeviceInteraction);
    document.addEventListener('scroll', inputDeviceInteraction, true);
    window.addEventListener('click', inputDeviceInteraction);
    window.addEventListener('keydown', inputDeviceInteraction);

    return () => {
      if (router?.events) {
        router.events.off('routeChangeStart', inputDeviceInteraction);
      }
      window.removeEventListener('focus', inputDeviceInteraction);
      document.removeEventListener('scroll', inputDeviceInteraction);
      window.removeEventListener('scroll', inputDeviceInteraction);
      window.removeEventListener('click', inputDeviceInteraction);
      window.removeEventListener('keydown', inputDeviceInteraction);
    };
  }, [router, inputDeviceInteraction]);

  return null;
};

export default InputDeviceActivity;
